import MaRefs from "src/modules/ma/classes/ma_refs";
import { EventItem, EventSession } from "../../models";

export interface EventsStateInterface {
  page_size: number;
  sessions: { [key: string]: EventSession };
  pagination_event_types: string[];
  new_events: EventItem[];
}

function state(): EventsStateInterface {
  return {
    page_size: 25,
    sessions: {},
    pagination_event_types: [
      MaRefs.str.ds_event_types.client_message,
      MaRefs.str.ds_event_types.bot_message,
      MaRefs.str.ds_event_types.operator_message,
      MaRefs.str.ds_event_types.bot_timer,
    ],
    new_events: [],
  };
}

export default state;
